import React from "react";

/*
 * Pampeliška — SVG motiv z loga Plevel design.
 *
 * Props:
 *   variant — "seedhead" (celá hlavička) | "seed" (jedno semínko-parachute)
 *   size    — velikost v px
 *   color   — barva
 *   opacity — průhlednost
 *   className, style — předané dál
 *
 * "seed" varianta vypadá jako klasické dandelion-semínko:
 * vějíř paprsků nahoře (pappus) s drobnými tečkami na koncích,
 * stonek a malé semínkové tělíčko dole. Stylem ladí s pampeliškou
 * z loga (ručně kreslený dojem).
 */
function Pampeliska({
  variant = "seedhead",
  size = 120,
  color = "#3d4a30",
  opacity = 1,
  className = "",
  style = {},
  ariaHidden = true,
}) {
  const common = {
    width: size,
    height: variant === "seed" ? Math.round(size * 1.35) : size,
    className: className,
    style: { opacity, ...style },
    "aria-hidden": ariaHidden,
    focusable: "false",
  };

  if (variant === "seed") {
    return (
      <svg {...common} viewBox="0 0 30 40" fill="none">
        <g stroke={color} strokeWidth="0.85" strokeLinecap="round">
          <line x1="15" y1="18" x2="3" y2="5" />
          <line x1="15" y1="18" x2="8" y2="2" />
          <line x1="15" y1="18" x2="15" y2="0.5" />
          <line x1="15" y1="18" x2="22" y2="2" />
          <line x1="15" y1="18" x2="27" y2="5" />
          <line x1="15" y1="18" x2="0.5" y2="13" />
          <line x1="15" y1="18" x2="29.5" y2="13" />
        </g>
        <g fill={color}>
          <circle cx="3" cy="5" r="0.95" />
          <circle cx="8" cy="2" r="0.95" />
          <circle cx="15" cy="0.5" r="1" />
          <circle cx="22" cy="2" r="0.95" />
          <circle cx="27" cy="5" r="0.95" />
          <circle cx="0.5" cy="13" r="0.85" />
          <circle cx="29.5" cy="13" r="0.85" />
        </g>
        <circle cx="15" cy="18" r="1.1" fill={color} />
        <line x1="15" y1="19" x2="15" y2="34" stroke={color} strokeWidth="0.9" strokeLinecap="round" />
        <ellipse cx="15" cy="36.5" rx="1.2" ry="2.5" fill={color} />
      </svg>
    );
  }

  return (
    <svg {...common} viewBox="0 0 100 100" fill="none" stroke={color} strokeWidth="0.8">
      <circle cx="50" cy="50" r="4" />
      <g strokeLinecap="round" strokeWidth="0.6">
        <line x1="50" y1="46" x2="50" y2="14" />
        <line x1="56" y1="47" x2="74" y2="22" />
        <line x1="44" y1="47" x2="26" y2="22" />
        <line x1="58" y1="49" x2="84" y2="38" />
        <line x1="42" y1="49" x2="16" y2="38" />
        <line x1="58" y1="51" x2="84" y2="62" />
        <line x1="42" y1="51" x2="16" y2="62" />
        <line x1="56" y1="53" x2="74" y2="78" />
        <line x1="44" y1="53" x2="26" y2="78" />
        <line x1="50" y1="54" x2="50" y2="86" />
      </g>
      <g fill={color}>
        <circle cx="50" cy="12" r="1.5" />
        <circle cx="76" cy="20" r="1.5" />
        <circle cx="24" cy="20" r="1.5" />
        <circle cx="86" cy="37" r="1.5" />
        <circle cx="14" cy="37" r="1.5" />
        <circle cx="86" cy="63" r="1.5" />
        <circle cx="14" cy="63" r="1.5" />
        <circle cx="76" cy="80" r="1.5" />
        <circle cx="24" cy="80" r="1.5" />
        <circle cx="50" cy="88" r="1.5" />
      </g>
    </svg>
  );
}

export default Pampeliska;
